export default __webpack_public_path__ + "static/media/squiggles.51ae651c.svg";